import { map, take } from 'rxjs/operators';
import { leftJoinQuery, leftJoin, leftJoinDocument } from './../../services/db.service';
import { AuthService } from './../../services/auth.service';
import { DbService } from 'src/app/services/db.service';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertDesignJustWordComponent } from '../alert-design-just-word/alert-design-just-word.component';
import { ChatBoxComponent } from '../template/chat-box/chat-box.component';
import { ActivatedRoute, Router } from '@angular/router';
import * as firebase from 'firebase/app';

@Component({
  selector: 'app-play-group-all',
  templateUrl: './play-group-all.component.html',
  styleUrls: ['./play-group-all.component.css']
})
export class PlayGroupAllComponent implements OnInit {

  boardSwitch = false;
  wlike = false;

  itemWord = [
    {
      title: 'mirror',
      con: {
        img: 'assets/imgs/mirror_icon.png',
        txt: '재미있는 제주 생활을 \n 만드는 스마트 거울', outBg: '#EA6687',
        innerBg: '#D84972'
      }
    },
    {

      title: 'speaker',
      con: {
        img: 'assets/imgs/speaker_icon.png',
        txt: '즐겁고 편리한 제주 생활을 \n만들어주는 스마트 스피커', outBg: '#F4B100',
        innerBg: '#F49302'
      }
    },
    {
      title: 'bicycle',
      con: {
        img: 'assets/imgs/bicycle_icon.png',
        txt: '아름다운 제주를\n 누비는 스마트 자전거', outBg: '#6D3582',
        innerBg: '#502785'
      }
    },
    {
      title: 'glasses',
      con: {
        img: 'assets/imgs/glasses_icon.png',
        txt: '보이지 않던 제주의 다양한 \n 모습까지 보여주는 스마트 안경', outBg: '#0064B3',
        innerBg: '#003E98'
      }
    },
    {
      title: 'blackboard',
      con: {
        img: 'assets/imgs/blackboard_icon.png',
        txt: '스마트한 제주 학교생활을 \n도와주는 스마트 칠판', outBg: '#52BA9F',
        innerBg: '#009EA0'
      }
    },
    {
      title: 'bag',
      con: {
        img: 'assets/imgs/bag_icon.png',
        txt: '제주의 어느 곳에서나 \n함께하는 스마트 가방', outBg: '#C0CC38',
        innerBg: '#5DB665'
      }
    },
  ];

  userId;
  student$;


  constructor(
    public dialog: MatDialog,
    public db: DbService,
    public auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.userId = localStorage.getItem('userId');

    this.route.queryParams.pipe(take(1)).subscribe(params => {
      // console.log('params', params);
      this.student$ = this.db.doc$(`groupFeed/${params.teacherCode}`);
    })
  }

  ngOnInit(): void {
    // this.endGame();
  }



  boardOn(): any {
    if (this.boardSwitch == false) {
      this.boardSwitch = true;
    } else {
      this.boardSwitch = false;
    }
  }



  openComment(code) {
    const dialogRef = this.dialog.open(ChatBoxComponent, {
      panelClass: 'chat_box',
      data: {
        feedCode: code
      }
    })
  }


  endGame(): any {
    const dialogRef = this.dialog.open(AlertDesignJustWordComponent, {
      panelClass: 'word_pop',
      data: { txt: '플레이가 종료되었습니다.' }
    });
  }

  timeOver(): any {
    const dialogRef = this.dialog.open(AlertDesignJustWordComponent, {
      panelClass: 'word_pop',
      data: { txt: '플레이 시간이 종료되었습니다.' }
    });
  }

  ilike(data, alllike) {
    const index = alllike.indexOf(this.userId);
    if (index > -1) {
      this.db.updateAt(`playUser/${data}`, {
        like: firebase.default.firestore.FieldValue.arrayRemove(this.userId)
      })
    } else {
      this.db.updateAt(`playUser/${data}`, {
        like: firebase.default.firestore.FieldValue.arrayUnion(this.userId)
      })
    }
  }

  likeTF(all) {
    const index = all.indexOf(this.userId);
    if (index > -1) {
      return true;
    } else {
      return false;
    }
  }


}
